export enum AccountReceivableEvidenceSource {
  CSVUpload = 'CSV_UPLOAD',
  BankApi = 'BANK_API',
  OCRServiceEMail = 'OCR_SERVICE_EMAIL',
  MailCourier = 'MAIL_COURIER',
  CreatedByUser = 'CREATED_BY_USER',
}

export default AccountReceivableEvidenceSource;
export type VerifyAccountReceivableEvidenceSource = Utils.VerifyExtends<
  Model.Enum.AccountReceivableEvidenceSource,
  Utils.ValueOf<typeof AccountReceivableEvidenceSource>
>;
